export enum CondicaoDePagamento {
  CONTADO = 'CONTADO',
  CREDITO = 'CREDITO',
}
